import * as alertify from 'alertifyjs'
window.alertify = alertify;
